import React from 'react'
import Loading from '@/common/atoms/Loading'
import ScrollableLayout from '@/common/atoms/ScrollableLayout'
import TextError from '@/common/atoms/TextError'
import { Title } from '@/common/atoms/Title'
import { Container, Flex, Heading, Text, VStack } from '@chakra-ui/react'
import { usePublishedReleasesQuery } from '@gql'
import { useTranslation } from 'react-i18next'
import settings from 'src/settings'
import ReleaseSection from '../components/ReleaseSection'

// #77 — every version Yohan published in the console, newest first and
// unfolded, the previous ones folded. Only what he kept or adjusted shows:
// Hasura does not hand members the rest.
export default function WhatsNewPage() {
  const { t } = useTranslation()
  const { data, loading, error } = usePublishedReleasesQuery()
  const releases = data?.release ?? []

  return (
    <ScrollableLayout
      header={
        <Flex ml={5} w="100%" alignItems="center">
          <Heading as="h1" size="lg" my={2}>
            {t('WhatsNewPage.heading')}
          </Heading>
        </Flex>
      }
    >
      <Title>{t('WhatsNewPage.heading')}</Title>

      <Container maxW="3xl" py={10}>
        <Loading center active={loading} />
        {error && <TextError error={error} />}

        {data && releases.length === 0 && (
          <Text color="gray.500">
            {t('WhatsNewPage.empty', { brand: settings.brand.name })}
          </Text>
        )}

        <VStack align="stretch" spacing={3}>
          {releases.map((release, index) => (
            <ReleaseSection
              key={release.version}
              release={release}
              latest={index === 0}
            />
          ))}
        </VStack>
      </Container>
    </ScrollableLayout>
  )
}
